import React, { useEffect, useState } from "react";
import { Formik, Field, ErrorMessage, Form, FieldArray } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPostsById } from "../../../../../redux/posts/action";
import { getPenalty } from "../../../../../redux/categary/action";
import { sendProjectProposal } from "../../../../../redux/project/action";
import { Tooltip } from "react-tooltip";
import { Modal } from "reactstrap";
import ProjectAddMilestones from "./ProjectAddMilestones";
import NumberInputBox from "../../../../CustomComponents/AllCustomeInput/NumberInputBox";
import { addpresent } from "../../../../Common/FewCommonMethods";
import { descriptionvalidation, titlevalidation } from "../../../../Common/commonvalidation";
import NumberInputBoxDuration from "../../../../CustomComponents/AllCustomeInput/NumberInputBoxDuration";
import { isPriceWithinBudget } from "../../../../../utils/isPriceWithinBudget";
import { isDurationLessThanMilestones } from "../../../../../utils/isDurationLessThanMilestones";
import AllTypeFilesUpload from "../../../../Common/Upload/AllTypeFilesUpload";
import AsteriskLabel from "../../../../Common/AsteriskLabel";
import { penaltytips } from "../../../../Common/Tooltips/tooltip";

const SubmitProjectProposalForm = () => {
  const [loading, setLoading] = useState(false);
  const [work_sample, setWork_sample] = useState();
  const [fileee, setFileee] = useState();
  const laung = localStorage.getItem("laung") || "en";
  const [lan, setLan] = useState(laung);
  const [MilesModel, setMilesModel] = useState(false);
  const posts = useSelector(({ posts: { postbyid } }) => postbyid);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    dispatch(getPenalty());
    dispatch(getPostsById(id));
  }, [dispatch, id]);

  useEffect(() => {
    LoadCSSforfirstTime("Assets/scss/FindWork.module.scss");
  }, []);

  // Move this useEffect outside of Formik
  const [initialValues, setInitialValues] = useState({
    message: "",
    price: "",
    duration: "",
    duration_type: "2",
    files: "",
    milestones: posts?.milestones || [],
  });

  useEffect(() => {
    if (posts?.milestones && Array.isArray(posts.milestones)) {
      setInitialValues({
        message: "",
        price: "",
        duration: "",
        duration_type: "2",
        files: "",
        milestones: posts.milestones,
      });
    }
  }, [posts]);

  const validationSchema = Yup.object().shape({
    message: descriptionvalidation,
    price: Yup.number().required("Proposed price is required").moreThan(0, 'Duration must be greater than 0').typeError('price must be a number'),
    duration: Yup.number().required("Project duration is required").moreThan(0, 'Duration must be greater than 0').typeError('Duration must be a number'),
    duration_type: Yup.string().required("Project duration type is required"),
    milestones: Yup.array()
      .of(
        Yup.object().shape({
          title: titlevalidation,
          duration: Yup.number()
            .required("This Field is Required")
            .test("not-zero", "Duration should not be 0", (value) => value > 0)
            .typeError("Duration must be a number"),
          duration_type: Yup.string()
            .required("Duration Type is Required")
            .test(
              "not-only-spaces",
              "Duration Type is Required",
              (value) => value.trim() !== "",
            ),
          amount: Yup.number()
            .required("This Field is Required")
            .test("not-zero", "Amount should not be 0", (value) => value > 0)
            .typeError("Amount must be a number"), // Ensures t
          penalty: Yup.string()
            .required("This Field is Required")
            .test(
              "not-only-spaces",
              "This Field is Required",
              (value) => value.trim() !== "",
            ),
        }),
      )
      .min(1, "At least one milestone is required"),
  });

  const handleSubmit = async (values, formikHelpers) => {
    const isDurationValid = isDurationLessThanMilestones(
      values.duration,
      values.duration_type,
      values.milestones
    );

    const isBudgetValid = isPriceWithinBudget(values.price, values.milestones);

    if (!isDurationValid || !isBudgetValid) {
      formikHelpers.setErrors({
        duration: !isDurationValid
          ? "Total milestone duration cannot exceed total project duration."
          : undefined,
        price: !isBudgetValid
          ? "Total milestone amounts cannot exceed project budget."
          : undefined,
      });
      return;
    }

    setLoading(true);
    const data = {
      ...values,
      files: fileee?.files,
      type: 1,
      post_id: posts.id,
      url: `/${lan}/praposedsuccessful`,
      proposal: true,
    };
    dispatch(sendProjectProposal(data, setLoading, navigate));
    setLoading(false);
  };

  useEffect(() => {
    setFileee(work_sample);
  }, [work_sample]);

  return (
    <>

      <Tooltip
        id="my-tooltip-1"
        place="bottom"
        content={penaltytips}
      />

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, setFieldValue, resetForm, errors }) => (
          <Form>
            <h6>Cover letter</h6>
            <div className=" ">
              <label>Your message <AsteriskLabel /></label>
              <Field
                as="textarea"
                className="form-control"
                name="message"
                placeholder="Enter your message"
              />
              <ErrorMessage name="message" component="div" className="error" />
            </div>
            <h6>Craft your proposal</h6>
            <div className="row">
              <div className="col-md-4  ">
                <NumberInputBox
                  title="Propose your price in $"
                  name="price"
                  placeholder="Enter proposed price"
                />
              </div>
              <div className="col-md-4  ">
                <label>Select Duration type <AsteriskLabel /></label>
                <Field
                  as="select"
                  className="form-control"
                  name="duration_type"
                >
                  <option value="2">Days</option>
                  <option value="3">Weeks</option>
                  <option value="4">Months</option>
                </Field>
                <ErrorMessage
                  name="duration_type"
                  component="div"
                  className="error"
                />
              </div>
              <div className="col-md-4  ">
                <NumberInputBoxDuration
                  title="Select Duration"
                  name="duration"
                  placeholder="Enter duration"
                />
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center addupdate-btn">
              <h6 className="m-0 p-0">Milestones</h6>
              <p className="buttons border-button" onClick={() => setMilesModel(true)}>
                Add/Update </p>
            </div>

            <Modal
              isOpen={MilesModel}
              keyboard={false}
              className="modal-centered popupmodal mile-modal w-50"

              size="xl"
            >
              <ProjectAddMilestones
                formikxxx={{ values, setFieldValue }}
                setMilesModel={setMilesModel}
              />
            </Modal>
            <FieldArray name="milestones">
              {({ push, remove }) => (
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Milestones</th>
                        <th>Deadline</th>
                        <th>Amount</th>
                        <th>
                          Penalty
                          <img
                            data-tooltip-id="my-tooltip-1"
                            src={`${CloudStorage.cloudurl}/Assets/Images/project/penalty.svg`}
                            alt=""
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {values.milestones?.map((milestone, index) => (
                        <tr key={index}>
                          <td>
                            {index + 1}. {milestone?.title}
                            <div>
                              <ErrorMessage
                                name={`milestones[${index}].title`}
                                component="div"
                                className="error"
                              />
                            </div>
                          </td>
                          <td>
                            {milestone.duration ? milestone.duration : "-----"} {' '}
                            {milestone?.duration_type == 2
                              ? "Days"
                              : milestone?.duration_type == 3
                                ? "Weeks"
                                : milestone?.duration_type == 4
                                  ? "Months"
                                  : ""}
                            <div>
                              <ErrorMessage
                                name={`milestones[${index}].duration`}
                                component="div"
                                className="error"
                              />
                            </div>
                          </td>
                          <td>
                            {milestone.amount ? "$" : ""}
                            {milestone.amount ? milestone.amount : "-----"}
                            <div>
                              <ErrorMessage
                                name={`milestones[${index}].amount`}
                                component="div"
                                className="error"
                              />
                            </div>
                          </td>
                          <td>
                            {milestone.penalty
                              ? addpresent(milestone?.penalty)
                              : "-----"}
                            <div>
                              <ErrorMessage
                                name={`milestones[${index}].penalty`}
                                component="div"
                                className="error"
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </FieldArray>
            {
              Array.isArray(values?.milestones) && values?.milestones?.length > 0 ? "" :
                <p className="error">Select at least one milestone</p>
            }

            <h6>Attachment (If any)</h6>
            <AllTypeFilesUpload
              setWork_sample={setWork_sample}
              selectedfiles={work_sample?.files}
            />

            <div className="submit-btn">
              <button
                type="button"
                onClick={() => navigate(`/${lan}/projectdetails/${posts.id}`)}
                className="btn"
              >
                Cancel
              </button>
              <button type="submit" disabled={loading} className="btn post-btn">
                Submit Proposal
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                  alt=""
                />
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default SubmitProjectProposalForm;
